module.exports = __webpack_public_path__ + "static/img/CC.f9843ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/payment/CC.jpg
// module id = 5FOA
// module chunks = 0